module.exports = __webpack_public_path__ + "catalog/items/radiator-old-style/OldStyleRadiator.png";